import { render, staticRenderFns } from "./StockToolPartyInfo.vue?vue&type=template&id=058afa7a&"
import script from "./StockToolPartyInfo.vue?vue&type=script&lang=js&"
export * from "./StockToolPartyInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection}, component.options.components || {})
